import { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { HooksService } from 'basic-components';
import { DataStorageEnums } from 'dashboard-services/api/dataStorage';
import { ReduxService } from 'dashboard-services/services';

import GroupDropdown from './GroupDropdown';
import KeyDropdown from './KeyDropdown';
import Tags from './Tags';
import ValueDropdown from './ValueDropdown';

import './FilterBody.scss';

const EMPTY_OBJ = {};

const FilterBody = ({ groupName = undefined, isMulti = false, metadata = EMPTY_OBJ, name, onChange, symbol = EMPTY_OBJ, ...props }) => {
  const [filterKey, setFilterKey] = useState(),
        [filterValue, setFilterValue] = useState(),
        [filterKeyType, setFilterKeyType] = useState(),
        keyRef = useRef(),
        valueRef = useRef(),
        prevFilterKey = HooksService.usePrevious(filterKey),
        prevFilterValue = HooksService.usePrevious(filterValue),
        onFinishPickingValue = useCallback(() => {
          if(filterKey && filterValue && filterKeyType) {
            onChange({
              groupName,
              symbol: filterKeyType === DataStorageEnums.KEY_TYPE.SYMBOL ? ReduxService.updateObject(symbol, { [filterKey]: filterValue }) : symbol,
              metadata: filterKeyType === DataStorageEnums.KEY_TYPE.METADATA ? ReduxService.updateObject(metadata, { [filterKey]: filterValue }) : metadata
            }, name)
            setFilterKey()
            setFilterValue()
            setFilterKeyType()
            keyRef.current?.dropdown?.current?.setValue?.(undefined)
            valueRef.current?.dropdown?.current?.setValue?.(undefined)
          }
        }, [filterKey, filterKeyType, filterValue, groupName, metadata, name, onChange, symbol])

  useEffect(() => {
    if((filterKey !== prevFilterKey || filterValue !== prevFilterValue) && !isMulti) {
      onFinishPickingValue()
    }
  }, [filterKey, filterValue, isMulti, onFinishPickingValue, prevFilterKey, prevFilterValue])

  useEffect(() => {
    keyRef.current?.refreshOptions?.()
    valueRef.current?.refreshOptions?.()
  }, [symbol, metadata])

  useEffect(() => {
    valueRef.current?.refreshOptions?.()
  }, [filterKey])

  return (
    <div className="data-science__pipeline-creator__body__options__resolver__bottom-row__symbol-filter">
      <GroupDropdown
          {...props}
          groupName={groupName}
          name={name}
          onChange={onChange}
      />
      <div className="data-science__pipeline-creator__body__options__resolver__bottom-row__symbol-filter__row">
        <KeyDropdown
            {...props}
            groupName={groupName}
            keyRef={keyRef}
            setFilterKey={setFilterKey}
            setFilterKeyType={setFilterKeyType}
        />
        <ValueDropdown
            {...props}
            filterKey={filterKey}
            groupName={groupName}
            isMulti={isMulti}
            onFinishPickingValue={onFinishPickingValue}
            setFilterValue={setFilterValue}
            valueRef={valueRef}
        />
      </div>
      <Tags
          groupName={groupName}
          metadata={metadata}
          name={name}
          onChange={onChange}
          symbol={symbol}
      />
    </div>
  )
}

FilterBody.propTypes = {
  groupName: PropTypes.string,
  isMulti: PropTypes.bool,
  metadata: PropTypes.object,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  symbol: PropTypes.object
}

export default FilterBody;